<div class="notif-engine-container">
  <div class="panel-header">
    <h3>{{ title }}</h3>
    <div class="header-actions">
      <i class="fa fa-refresh gt-refresh" (click)="refresh()" title="Refresh Data"></i>
      <button type="button" class="cancel-button" (click)="cancel()">Close</button>
    </div>
  </div>
  <div class="panel-body">
    <div class="gt-filter-container">
      <select class="form-control col notif-type-select" [(ngModel)]="notifType" (ngModelChange)="onNotifChange()">
        @for (t of notifs; track $index) {
<option [value]="t.value">{{ t.label }}</option>
}
      </select>
      @if (notifType === 1) {
<div class="date-filters">
        <input type="text" class="form-control" [(ngModel)]="dateFilterFrom" placeholder="Start date" />
        <input type="text" class="form-control" [(ngModel)]="dateFilterTo" placeholder="End date" />
      </div>
}
      <button type="button" class="save-button" (click)="go()">Go</button>
    </div>

    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
      <span>Loading...</span>
    </div>
}
    @if (!loading && errorMessage) {
<div class="alert alert-error">
      {{ errorMessage }}
    </div>
}
    @if (!loading && showGrid && !errorMessage && gridPayload) {
<div class="grid-wrapper">
      @if (gridColumns.length > 0) {
<table class="table table-bordered form-inline custom-table">
        <thead>
          <tr>
            @for (col of gridColumns; track $index) {
<th>{{ col }}</th>
}
            @if (notifType === 3) {
<th>Action</th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of gridRows; track $index) {
<tr>
            @for (col of gridColumns; track $index) {
<td>
              @if (col === 'NOTIFDETID') {
<a (click)="openNotifDetails(row)" class="notif-link">{{ row[col] }}</a>
} @else {
{{ row[col] }}
}
              
            </td>
}
            @if (notifType === 3) {
<td>
              <button type="button" class="reset-button" (click)="openMaintenance(row)">Maintain</button>
            </td>
}
          </tr>
}
        </tbody>
      </table>
}
      @if (gridColumns.length === 0 && gridRows.length === 0) {
<p class="no-data">No records to display.</p>
}
    </div>
}

    @if (hasNotifDetails) {
<div class="notif-details-panel">
      <div class="modal-header">
        <h3 class="modal-title">
          {{ selectedNotif?.NOTIFDETID || 'Notification' }}
          <i class="fa fa-times pull-right" (click)="closeNotifDetails()"></i>
        </h3>
      </div>
      <div class="modal-body">
        <ul class="nav nav-pills">
          <li [class.active]="activeDetailTab === 'details'"><a (click)="setDetailTab('details')">Details</a></li>
          <li [class.active]="activeDetailTab === 'publishers'"><a (click)="setDetailTab('publishers')">Publishers</a></li>
          <li [class.active]="activeDetailTab === 'render'"><a (click)="setDetailTab('render')">Render</a></li>
          <li [class.active]="activeDetailTab === 'writer'"><a (click)="setDetailTab('writer')">Writer</a></li>
        </ul>

        @if (activeDetailTab === 'details') {
<div class="notif-detail-body">
          <p><b>Notification ID:</b> {{ selectedNotif?.NOTIFDETID }}</p>
          <p><b>Notification Name:</b> {{ selectedNotif?.NOTIFNAME }}</p>
          <p><b>Notification Key:</b> {{ selectedNotif?.NOTIFKEY }}</p>
          <p><b>Notification Initiated On:</b> {{ selectedNotif?.NOTIFGENERATEDON }}</p>
        </div>
}
        @if (activeDetailTab === 'publishers') {
<div class="notif-detail-body">
          <p><b>Notification Staged In:</b> {{ selectedNotif?.NOTIFPUBLISHNAME }}</p>
        </div>
}
        @if (activeDetailTab === 'render') {
<div class="notif-detail-body">
          <p><b>Render As:</b> {{ selectedNotif?.RENDERNAME }}</p>
          <p><b>Render Type:</b> {{ selectedNotif?.RENDERTYPENAME }}</p>
          <p><b>Rendering Status:</b> {{ selectedNotif?.RENDERSTATUS }}</p>
          <p><b>Rendering Started On:</b> {{ selectedNotif?.RENDERINGSTARTON }}</p>
          <p><b>Rendering Completed On:</b> {{ selectedNotif?.RENDERINGCOMPLETEDON }}</p>
        </div>
}
        @if (activeDetailTab === 'writer') {
<div class="notif-detail-body">
          <p><b>Sent As:</b> {{ selectedNotif?.WRITER_NAME }}</p>
          <p><b>Send Started On:</b> {{ selectedNotif?.SENDSTARTON }}</p>
          <p><b>Sent On:</b> {{ selectedNotif?.SENTON }}</p>
        </div>
}
      </div>
      <div class="modal-footer">
        <button type="button" class="save-button" (click)="saveNotifDetails()">Save</button>
        <button type="button" class="cancel-button" (click)="closeNotifDetails()">Cancel</button>
      </div>
    </div>
}

    @if (showMaintenancePanel) {
<div class="notif-details-panel maintenance-panel">
      <div class="modal-header">
        <h3 class="modal-title">
          Maintenance Notification
          <i class="fa fa-times pull-right" (click)="closeMaintenance()"></i>
        </h3>
      </div>
      <div class="modal-body">
        <div class="divShadow">
          <div class="maint-header-row">
            <h4>Manage/Configure Rules Engine</h4>
            <button type="button" class="cancel-button" (click)="closeMaintenance()">Close</button>
          </div>
        </div>
        <div class="divShadow">
          <div class="maint-title">Maintenance Notifications</div>
          @if (maintenanceRow) {
<div class="maint-row-data">
            <table class="table table-bordered form-inline custom-table">
              <tbody>
                @for (col of gridColumns; track $index) {
<tr>
                  <td><strong>{{ col }}</strong></td>
                  <td>{{ maintenanceRow[col] }}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
}
          <div class="maint-footer">
            <button type="button" class="cancel-button" (click)="closeMaintenance()">Close</button>
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>
